/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const fieldValueObjectSchema = z.object({
  description: z.string().nullish(),
  id: z.int(),
  value: z.union([z.boolean(), z.string(), z.number()]).nullish(),
});
